// extracted by mini-css-extract-plugin
export default {"header":"style_header__TOM+P","title":"style_title__LXgXx"};